<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>

<style scoped>
  .footer{
    background-color: #141414;
    padding: 1rem 0rem;
  }
  .darkmode .footer {
    background-color: #1F213F;
  }
</style>

<template>
  <footer class="footer">
    <b-container class="text-center">
      <a href="https://spendid.io">
        <img src="footer-logo.png" width="60" height="60" />
      </a>
      <p class="text-white mt-2 mb-0 font-weight-bold">"Done For You" Predictive Budgeting</p>
    </b-container>
  </footer>
</template>



